module.exports = __webpack_public_path__ + "img/continuous-learning.6cd61cfa.svg";